<script setup lang="ts">
import type { HotKeySize, Key } from './HotKey.vue'
import HotKey from './HotKey.vue'

withDefaults(
  defineProps<{
    keys: Key[]
    size?: HotKeySize
  }>(),
  {
    size: 'md',
  },
)
</script>

<template>
  <div class="flex items-center gap-0.5">
    <HotKey
      v-for="(k, i) in keys"
      :key="k + i"
      :hotkey="k"
      :size="size"
    />
  </div>
</template>
